import React from 'react';
import { Paper, InputBase, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { designTokens } from '../../styles/designTokens';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: 380,
        backgroundColor: designTokens.colors.grey[100],
        borderRadius: designTokens.borderRadius.input,
        padding: '8px 12px 6px',
        border: 'none',
        boxShadow: 'none',
        '@media (max-width: 900px)': {
            minWidth: 'auto',
        }
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        fontSize: '14px',
        lineHeight: '18px',
        fontWeight: 400,
        fontFamily: designTokens.fontFamily,
        letterSpacing: '0',
        color: designTokens.colors.text.primary,
        '& input::placeholder': {
            color: designTokens.colors.grey[300],
            opacity: 1,
        }
    },
    iconButton: {
        padding: 8,
        color: designTokens.colors.primary,
    },
    searchIcon: {
        color: designTokens.colors.primary,
        width: '20px',
        height: '20px',
    },
    clearButton: {
        padding: 4,
        backgroundColor: designTokens.colors.grey[200],
        width: '24px',
        height: '24px',
        '&:hover': {
            backgroundColor: designTokens.colors.grey[300],
        }
    },
    clearIcon: {
        color: designTokens.colors.text.primary,
        width: '16px',
        height: '16px',
    }
}));

const SearchInput = ({
    value,
    onChange,
    onSearch,
    placeholder = "Пошук"
}) => {
    const classes = useStyles();

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (onSearch) {
            onSearch(event);
        }
    };

    const handleClear = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (onChange) {
            onChange({ target: { value: '' } });
        }
    };

    return (
        <Paper component="form" className={classes.root} elevation={0} onSubmit={handleSubmit}>
            <SearchIcon className={classes.searchIcon} />
            <InputBase
                className={classes.input}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                inputProps={{ 'aria-label': 'search' }}
            />
            {value && (
                <IconButton
                    className={classes.clearButton}
                    onClick={handleClear}
                    size="small"
                    aria-label="clear search"
                >
                    <CloseIcon className={classes.clearIcon} />
                </IconButton>
            )}
        </Paper>
    );
};

export default SearchInput;
